module.exports = __webpack_public_path__ + "static/media/UPWK.f973d9c7.svg";